/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import CloseModal from '../close-modal/close-modal';

export class GeneralTerms extends React.Component {

  static propTypes = {
    generalTerms: PropTypes.object
  };

  constructor (props) {
    super(props);

    this.state = {
      showModal: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal (e) {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  renderModal () {
    if (this.state.showModal) {
      return <CloseModal
        headline={this.props.generalTerms.headline}
        body={this.props.generalTerms.text}
        close={this.toggleModal}/>;
    }
  }

  render () {
    return (
      <div className='general-terms'>
        <Translate content='APPROVE_TERMS'/> Frilans&nbsp;Finans&nbsp;
        <a href="#" onClick={this.toggleModal}>
          <Translate content='GENERAL_TERMS'/>
        </a>
        {this.renderModal()}
      </div>
    );
  }
}

export default GeneralTerms;



/** WEBPACK FOOTER **
 ** ./src/components/general-terms/general-terms.js
 **/